import { createSlice } from '@reduxjs/toolkit'
import {
  SET_EDITING,
  SET_CHANGING,
  CHANGING_CHANGE_TO_SEARCHING,
  CHANGING_CHANGE_TO_CREATING,
  CHANGING_SEARCH_CUSTOMER_REQUEST,
  CHANGING_SEARCH_CUSTOMER_FAILURE,
  CHANGING_SEARCH_CUSTOMER_SUCCESS,
  CHANGING_ADD_NEW_CUSTOMER_REQUEST,
  CHANGING_SELECT_CUSTOMER_REQUEST,
  CHANGING_SELECT_CUSTOMER_SUCCESS,
  CHANGING_SELECT_CUSTOMER_FAILURE,
} from './types'

const defaultState = {
  isEditing: false,
  isChanging: false,
  changing: {
    search: {
      isLoading: false,
      isError: false,
      term: '',
      matchingCustomers: [],
    },
    create: {
      isLoading: false,
      isError: false,
    },
    isSearching: true,
    isCreating: false,
  },
}

const SLICE_NAME = 'inappcards/customer'
const localType = type => type.replace(`${SLICE_NAME}/`, '')

const customer = createSlice({
  name: SLICE_NAME,
  initialState: defaultState,
  reducers: {
    [localType(SET_EDITING)]: (draftState, { payload }) => {
      const { isEditing } = payload
      draftState.isEditing = isEditing
    },
    [localType(SET_CHANGING)]: (draftState, { payload }) => {
      const { isChanging } = payload
      draftState.changing = defaultState.changing
      draftState.isChanging = isChanging
    },
    [localType(CHANGING_CHANGE_TO_SEARCHING)]: draftState => {
      draftState.changing.isSearching = true
      draftState.changing.isCreating = false
    },
    [localType(CHANGING_CHANGE_TO_CREATING)]: draftState => {
      draftState.changing.isSearching = false
      draftState.changing.isCreating = true
      draftState.changing.create = defaultState.changing.create
    },
    [localType(CHANGING_SELECT_CUSTOMER_REQUEST)]: draftState => {
      draftState.changing.search.isLoading = true
      draftState.changing.search.isError = false
    },
    [localType(CHANGING_SELECT_CUSTOMER_SUCCESS)]: draftState => {
      draftState.changing.search.isLoading = false
    },
    [localType(CHANGING_SELECT_CUSTOMER_FAILURE)]: draftState => {
      draftState.changing.search.isLoading = false
      draftState.changing.search.isError = true
    },
    [localType(CHANGING_SEARCH_CUSTOMER_REQUEST)]: (
      draftState,
      { payload }
    ) => {
      const { term } = payload
      draftState.changing.search.term = term
      draftState.changing.search.isLoading = true
      draftState.changing.search.isError = false
    },
    [localType(CHANGING_SEARCH_CUSTOMER_SUCCESS)]: (
      draftState,
      { payload }
    ) => {
      const { results: matchingCustomers } = payload
      draftState.changing.search.matchingCustomers = matchingCustomers
      draftState.changing.search.isLoading = false
    },
    [localType(CHANGING_SEARCH_CUSTOMER_FAILURE)]: draftState => {
      draftState.changing.search.matchingCustomers = []
      draftState.changing.search.isLoading = false
      draftState.changing.search.isError = true
    },
    [localType(CHANGING_ADD_NEW_CUSTOMER_REQUEST)]: draftState => {
      draftState.changing.create.isLoading = true
      draftState.changing.create.isError = false
    },
  },
})

export default customer.reducer
